'use client';

import React from 'react';
import { FaArrowUpFromBracket } from 'react-icons/fa6';

const ScrollToTop: React.FC = () => {
  const handleScrollToTop = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <a
      href="#"
      className="scrollToTop scrollToTop--style1"
      onClick={handleScrollToTop}
    >
      <FaArrowUpFromBracket />
    </a>
  );
};

export default ScrollToTop;
